// extracted by mini-css-extract-plugin
export default {"labelText":"Label_labelText__xGPSp"};